<template>
  <div>
    <!-- {{ $route.name + ',' + $route.path}} -->
    <el-dialog :visible.sync="showExamine" fullscreen id="onlineCheck" v-loading="iframeLoading">
      <div class="back" @click="$router.push({ path: '/home' })">返回</div>
      <iframe id="examineIframe" ref="iframe" :src="iframeSrc" allowfullscreen></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import bUtils from 'babyeye-utils'
// import screenfull from 'screenfull'

import { namespace } from 'vuex-class'
const moduleUser = namespace('user')

@Component
export default class Examine extends Vue {
  iframeLoading = false
  showExamine = true
  iframeSrc = ''

  @moduleUser.Getter uid
  @moduleUser.Getter name
  @moduleUser.Getter age
  @moduleUser.Getter gender
  @moduleUser.Getter hid

  created() {
    this.addParams()
  }
  mounted() {
    this.$nextTick(() => {
      this.iframeLoading = true
      const oIfrm = this.$refs.iframe
      // console.log(window.frames['examineIframe'])
      this.elLoaded(oIfrm)
        .then(() => {
          console.log('loaded')
          this.iframeLoading = false
        })
        .catch(() => {
          console.log('err loaded')
          this.iframeLoading = false
        })
    })
  }
  elLoaded(el) {
    return new Promise((resolve, reject) => {
      if (el && typeof el === 'object') {
        el.onload = () => resolve()
        el.onerror = () => reject()
      }
    })
  }
  addParams() {
    const params = {
      timestamp: new Date().getTime(),
      username: this.name,
      uid: this.uid,
      age: this.age,
      gender: this.gender,
      hid: this.hid,
    }
    const baseUrl = process.env.VUE_APP_EXAMINE_URL
    this.iframeSrc = decodeURIComponent(bUtils.addParamsToUrl(baseUrl, params))
  }
}
</script>

<style lang="scss" scoped>
.back {
  cursor: pointer;
  z-index: 99999;
  position: absolute;
  bottom: 64px;
  right: 40px;
  display: inline-block;
  width: 54px;
  height: 54px;
  text-align: center;
  line-height: 54px;
  color: #fff;
  background: #fd9c27;
  border-radius: 50%;
  font-size: 16px;
}
</style>
